// TODO: Come back to this ignore line
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { matchPath } from 'react-router-dom';
import history from 'common/history';
import NavBarLinks from './NavBarLinks';
import Search from './Search';
import Logo from './Logo';
import classnames from 'classnames';
import Notifications from './Notifications';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import { connect } from 'react-redux';
import { updateCase } from 'features/case/redux/actions';
import { selectBundleTabPage, selectChangeCaseName, selectUseOldFilter } from 'common/selectors';

class NavBar extends Component {
  static propTypes = {
    search: PropTypes.any,
    searchFunctions: PropTypes.object,
    showHearingRoom: PropTypes.bool,
    showLogo: PropTypes.bool,
    updateCasePending: PropTypes.bool,
    updateCase: PropTypes.func,
    canChangeCaseName: PropTypes.bool,
    brandText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    theme: PropTypes.string,
    additionalButton: PropTypes.any,
  };

  static defaultProps = {
    showLogo: false,
  };

  constructor(props) {
    super(props);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.editContainerRef = React.createRef();
    this.state = {
      sidebarExists: false,
      isEditingCaseName: false,
      isHoveringCaseName: false,
      caseNameDraft: '',
    };
  }

  shouldHideCaseNameEdit = () => {
    // Hide edit on file viewer and hearing room routes
    const path = history.location.pathname;
    return (
      !!matchPath(path, { path: '/case/:case/files/:file' }) ||
      !!matchPath(path, { path: '/case/:case/public-hearing-room' }) ||
      !!matchPath(path, { path: '/case/:case/public-hearing-room/document-presentation' }) ||
      !!matchPath(path, { path: '/case/:case/files/public-hearing-room/document-presentation' })
    );
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (
      this.state.isEditingCaseName &&
      this.editContainerRef.current &&
      !this.editContainerRef.current.contains(e.target)
    ) {
      this.cancelEditingCaseName();
    }
  };

  handleCaseNameMouseEnter = () => this.setState({ isHoveringCaseName: true });
  handleCaseNameMouseLeave = () => this.setState({ isHoveringCaseName: false });
  startEditingCaseName = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (this.shouldHideCaseNameEdit()) return;
    this.setState({ isEditingCaseName: true, caseNameDraft: this.props.brandText || '' });
  };
  cancelEditingCaseName = () => {
    this.setState({ isEditingCaseName: false, isHoveringCaseName: false, caseNameDraft: '' });
  };
  handleCaseNameChange = (e) => this.setState({ caseNameDraft: e.target.value });
  handleSaveCaseName = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    const name = (this.state.caseNameDraft || '').trim();
    if (!name || name === this.props.brandText) return;
    const p = this.props.updateCase({ name });
    Promise.resolve(p)
      .then(() => {
        this.setState({ isEditingCaseName: false, isHoveringCaseName: false });
      })
      .catch(() => {});
  };

  isCurrentRoute(pattern) {
    const currentPath = history.location.pathname;
    const match = matchPath(currentPath, { path: pattern });
    return Boolean(match);
  }
  checkIsFileViewRoute() {
    return this.isCurrentRoute('/case/:case/files/:file');
  }

  mobileSidebarToggle(e) {
    if (this.state.sidebarExists === false) {
      this.setState({
        sidebarExists: true,
      });
    }
    e.preventDefault();
    document.documentElement.classList.toggle('nav-open');
    var node = document.createElement('div');
    node.id = 'bodyClick';
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle('nav-open');
    };
    document.body.appendChild(node);
  }

  searchRef = null;
  setSearchValue = (val) => {
    try {
      // NavBar renders <Search /> and stores a ref to its clear function; we also want to set value
      // Reach into the Search component instance via DOM to set the input value by dispatching events
      // Prefer using the Search component API when available; fallback to DOM input
      const inputs = document.querySelectorAll('.navbar .search input[type="search"]');
      if (inputs && inputs[0]) {
        const input = inputs[0];
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
          window.HTMLInputElement.prototype,
          'value',
        )?.set;
        if (nativeInputValueSetter) nativeInputValueSetter.call(input, val);
        const ev = new Event('input', { bubbles: true });
        input.dispatchEvent(ev);
      }
    } catch {
      // no-op
    }
  };

  render() {
    const isFileViewRoute = this.checkIsFileViewRoute();
    const url = new URL(window.location.href);
    const preview = url.searchParams.get('preview');
    const fileId = url.pathname.split('/').pop();
    const currentPath = url.pathname || '';
    const folderIdFromSearch = url.searchParams.get('folderId');
    const isBigViewScreen =
      !!folderIdFromSearch &&
      folderIdFromSearch !== 'recordings' &&
      /^\/case\/[^/]+\/files\/[^/]+$/.test(currentPath) &&
      url.searchParams.get('view') !== 'share';
    const truncateName = (value, maxLength) => {
      if (!value) return '';
      if (value.length <= maxLength) return value;
      return `${value.slice(0, Math.max(maxLength - 3, 0))}...`;
    };
    const formatDocDisplay = (message) => {
      if (!message) return '';
      const details = message.currentFileDetails || {};
      const fileIdValue = message.fileId || '';
      const docName = details.name || details.fileName || message.name || '';
      const truncatedName = truncateName(docName, this.props.btpActive ? 40 : 50);
      const nameSegment = truncatedName ? ` ${truncatedName}` : '';

      if (this.props.btpActive) {
        const prefix = details.globalPagePrefix;
        const tab = details.tab;
        const parts = [];
        if (prefix !== undefined && prefix !== null) parts.push(prefix);
        if (tab !== undefined && tab !== null) parts.push(tab);
        const pageInfo = parts.length ? `[${parts.join('/')}] ` : '';
        return `${pageInfo}${fileIdValue}${nameSegment}`;
      }

      const base = fileIdValue;
      return `${base}${nameSegment}`;
    };
    const getBrandTextDisplay = (brandText) => {
      const targetLength = 80;
      if (!isBigViewScreen || typeof brandText !== 'string') {
        return { displayText: brandText, tooltipText: null, isTruncated: false };
      }
      if (brandText.length <= targetLength) {
        return { displayText: brandText, tooltipText: null, isTruncated: false };
      }
      const arrowToken = ' > ';
      const firstArrowIndex = brandText.indexOf(arrowToken);
      let suffixIndex = brandText.lastIndexOf(' - (');
      if (suffixIndex === -1) suffixIndex = brandText.lastIndexOf(' - ');
      if (suffixIndex === -1) suffixIndex = brandText.lastIndexOf('-');
      const prefixEnd = firstArrowIndex !== -1 ? firstArrowIndex + arrowToken.length : 0;
      const suffixStart = suffixIndex !== -1 ? suffixIndex : brandText.length;
      if (prefixEnd > 0 && suffixStart > prefixEnd) {
        const prefix = brandText.slice(0, prefixEnd);
        const suffix = brandText.slice(suffixStart);
        const minMiddleLength = targetLength - (prefix.length + 3 + suffix.length);
        if (minMiddleLength <= 0) {
          return {
            displayText: `${prefix}...${suffix}`,
            tooltipText: brandText,
            isTruncated: true,
          };
        }
        const middleChunk = brandText.slice(prefixEnd, prefixEnd + minMiddleLength);
        return {
          displayText: `${prefix}${middleChunk}...${suffix}`,
          tooltipText: brandText,
          isTruncated: true,
        };
      }
      const keepStart = Math.ceil((targetLength - 3) / 2);
      const keepEnd = Math.floor((targetLength - 3) / 2);
      return {
        displayText: `${brandText.slice(0, keepStart)}...${brandText.slice(-keepEnd)}`,
        tooltipText: brandText,
        isTruncated: true,
      };
    };
    const brandTextDisplay = getBrandTextDisplay(this.props.brandText);
    const brandTextNode = brandTextDisplay.isTruncated ? (
      <Tooltip title={brandTextDisplay.tooltipText} arrow>
        <span>{brandTextDisplay.displayText}</span>
      </Tooltip>
    ) : (
      <span>{brandTextDisplay.displayText}</span>
    );

    if (preview) {
      return (
        <Navbar className={classnames(this.props.theme, { 'nav-flex': this.props.isDataRoom })}>
          <h4 style={{ marginRight: '1rem' }}>Preview Mode</h4> <h5>Doc ID: {fileId}</h5>
        </Navbar>
      );
    }
    return (
      <Navbar className={classnames(this.props.theme, { 'nav-flex': this.props.isDataRoom })}>
        {this.props.showLogo && <Logo showText={false} />}
        {this.props.bundleLocations && (
          <Nav style={{ marginLeft: '0.5rem' }}>
            <div className="nav-bar-links">{this.props.bundleLocations}</div>
          </Nav>
        )}
        <Navbar.Brand
          style={{ ...((this.props.showLogo || this.props.bundleLocations) && { marginLeft: 0 }) }}
          className={this.props.className}
        >
          {this.props.messages && this?.props?.messages?.length > 1 ? (
            <span
              className="docBeingPresentedText"
              style={{ flexDirection: 'row', display: 'flex', marginTop: '0.5rem' }}
            >
              <p>{formatDocDisplay(this.props.messages?.[0] || {})}</p>
              <p
                style={{
                  alignSelf: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  textAlign: 'center',
                  marginLeft: '0.5rem',
                  position: 'absolute',
                  left: '50%',
                }}
              >
                {formatDocDisplay(this.props.messages?.[1] || {})}
              </p>
            </span>
          ) : (
            <>
              {this.props.brandLink ? (
                <>
                  <span
                    className="brandLink"
                    onMouseEnter={this.handleCaseNameMouseEnter}
                    onMouseLeave={this.handleCaseNameMouseLeave}
                    onClick={() =>
                      !this.state.isEditingCaseName &&
                      history.push(
                        history.location.pathname.replace(/\/case.*/, ``) +
                          `/case/${this.props.brandLink.currentCaseId}`,
                      )
                    }
                    style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}
                  >
                    {this.props.showBackIcon && <ChevronLeftIcon style={{ color: '#777' }} />}
                    {this.state.isEditingCaseName &&
                    this.props.canChangeCaseName &&
                    typeof this.props.brandText === 'string' ? (
                      <span
                        ref={this.editContainerRef}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}
                      >
                        <TextField
                          size="small"
                          value={this.state.caseNameDraft}
                          onChange={this.handleCaseNameChange}
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') this.handleSaveCaseName(e);
                            if (e.key === 'Escape') this.cancelEditingCaseName();
                          }}
                          variant="outlined"
                          autoFocus
                        />
                        <IconButton
                          size="small"
                          onClick={this.handleSaveCaseName}
                          disabled={
                            this.props.updateCasePending ||
                            !this.state.caseNameDraft.trim() ||
                            this.state.caseNameDraft.trim() === this.props.brandText
                          }
                          aria-label="Save case name"
                        >
                          {this.props.updateCasePending ? (
                            <CircularProgress size={16} />
                          ) : (
                            <SaveIcon fontSize="small" />
                          )}
                        </IconButton>
                      </span>
                    ) : (
                      <>
                        {brandTextNode}
                        {this.state.isHoveringCaseName &&
                        this.props.canChangeCaseName &&
                        !this.shouldHideCaseNameEdit() &&
                        typeof this.props.brandText === 'string' ? (
                          <IconButton
                            size="small"
                            onClick={this.startEditingCaseName}
                            onMouseDown={(e) => e.stopPropagation()}
                            aria-label="Edit case name"
                            sx={{ ml: 0.5 }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        ) : null}
                      </>
                    )}
                  </span>
                </>
              ) : (
                <span
                  onMouseEnter={this.handleCaseNameMouseEnter}
                  onMouseLeave={this.handleCaseNameMouseLeave}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}
                >
                  {this.state.isEditingCaseName &&
                  this.props.canChangeCaseName &&
                  !this.shouldHideCaseNameEdit() &&
                  typeof this.props.brandText === 'string' ? (
                    <span
                      ref={this.editContainerRef}
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}
                    >
                      <TextField
                        size="small"
                        value={this.state.caseNameDraft}
                        onChange={this.handleCaseNameChange}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') this.handleSaveCaseName(e);
                          if (e.key === 'Escape') this.cancelEditingCaseName();
                        }}
                        variant="outlined"
                        autoFocus
                      />
                      <IconButton
                        size="small"
                        onClick={this.handleSaveCaseName}
                        disabled={
                          this.props.updateCasePending ||
                          !this.state.caseNameDraft.trim() ||
                          this.state.caseNameDraft.trim() === this.props.brandText
                        }
                        aria-label="Save case name"
                      >
                        {this.props.updateCasePending ? (
                          <CircularProgress size={16} />
                        ) : (
                          <SaveIcon fontSize="small" />
                        )}
                      </IconButton>
                    </span>
                  ) : (
                    <>
                      {brandTextNode}
                      {this.state.isHoveringCaseName &&
                      this.props.canChangeCaseName &&
                      !this.shouldHideCaseNameEdit() &&
                      typeof this.props.brandText === 'string' ? (
                        <IconButton
                          size="small"
                          onClick={this.startEditingCaseName}
                          aria-label="Edit case name"
                          sx={{ ml: 0.5 }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      ) : null}
                    </>
                  )}
                  {this.props.confidentialityRingLabel && this.props.confidentialityRingLabel}
                </span>
              )}
            </>
          )}
        </Navbar.Brand>
        <Nav className="mr-auto" />
        <Nav>
          {(!isFileViewRoute || this.props.isSharing) && (
            <Search
              ref={(el) => {
                this.searchRef = el && el.clear;
              }}
              isBundleTabPage={this.props.isBundleTabPage}
              currentDocument={this.props.currentDocument}
              search={this.props.search}
              searchFunctions={this.props.searchFunctions}
              hasSearch={this.props.hasSearch}
              clickToSearch={this.props.clickToSearch}
              hasDocFinderFilter={this.props.hasDocFinderFilter}
              setShowDocFinderFilter={this.props.setShowDocFinderFilter}
              showDocFinderFilter={this.props.showDocFinderFilter}
              useOldFilter={this.props.useOldFilter}
            />
          )}
          <Notifications mainTheme={this.props.theme} />
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
          <NavBarLinks
            theme={this.props.theme}
            additionalButton={this.props.additionalButton}
            showHearingRoom={this.props.showHearingRoom}
          />
        </Nav>
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => ({
  updateCasePending: state.case.updateCasePending,
  canChangeCaseName: selectChangeCaseName(state),
  btpActive: selectBundleTabPage(state),
  useOldFilter: selectUseOldFilter(state),
});

const mapDispatchToProps = {
  updateCase,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(NavBar);
